export const paymentColumns = ({
    excludeUser
}) => {
    let columns = [
        {
            text: 'User Name',
            value: 'userName'
        },
        {
            text: 'Mobile',
            value: 'mobileNo'
        },
        {
            text: 'Email',
            value: 'email'
        },
        {
            text: 'Amount',
            value: 'amount'
        },
        {
            text: 'Status',
            value: 'status'
        }
    ];
    if(excludeUser) {
        columns = columns.filter(c => {
            const { text } = c;
            if (text.match(/user name/i) || text.match(/mobile/i) || text.match(/email/i))
                return false;
            return true;
        })
    }
    return columns;
};

export const addColumns = ({
    excludeUser
}) => {
    let columns = [
        {
            text: 'User Name',
            value: 'userName'
        },
        {
            text: 'Mobile',
            value: 'user.mobile'
        },
        {
            text: 'Email',
            value: 'user.email'
        },
        {
            text: 'Plan Name',
            value: 'master.planName'
        },
        {
            text: 'Plan Type',
            value: 'master.planType'
        },
        {
            text: 'Amount',
            value: 'totalCharge'
        },
        {
            text: 'Status',
            value: 'status'
        }
    ];
    if(excludeUser) {
        columns = columns.filter(c => {
            const { text } = c;
            if (text.match(/user name/i) || text.match(/mobile/i) || text.match(/email/i))
                return false;
            return true;
        })
    }
    return columns;
}